import React, { useEffect, useState } from "react";
import Breadcrumb from "../../components/common/BreadCrumb";
import { Badge } from "../../components/micro/input";
import ReactSelect from "react-select";
import DebounceSearch from "../../components/common/DebounceSearch";
import CustomTable from "../../components/customTable/CustomTable";
import { SortDownArrow } from "../../assets/svg";
import Action from "../../components/common/Action";
import { getServiceList } from "../../redux/service/slice";
import RippleLoader from "../../components/RippleLoader/RippleLoader";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import SignatureModal from "./SignatureModal";

const Type = [
  { id: 1, value: "repair", label: "Repair" },
  { id: 2, value: "follow up repair", label: "Follow Up Repair" },
  { id: 3, value: "servicing", label: "Servicing" },
];

const Status = [
  { id: 1, label: "All", value: "all" },
  { id: 2, label: "Pending", value: "Pending" },
  { id: 3, label: "Scheduled", value: "Scheduled" },
  { id: 3, label: "Incomplete", value: "incompleted" },
  { id: 4, label: "Completed", value: "Completed" },
  { id: 5, label: "Cancelled", value: "Cancelled" },
];

const ServiceRequest = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchValue, setSearchValue] = useState("");
  const [selectedType, setSelectedType] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [pageLimit, setPageLimit] = useState(10);
  const [pageCount, setPageCount] = useState(1);
  const [activeTab, setActiveTab] = useState("all");
  const [sortBy, setSortBy] = useState("");
  const [sortDirection, setSortDirection] = useState("desc");
  const [selectedService, setSelectedService] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const {
    getServiceListData,
    totalCount,
    totalLeftCount,
    loading,
    createdDate,
  } = useSelector((store) => ({
    getServiceListData: store?.serviceData?.getServiceListStatus?.data?.data,
    totalCount:
      store?.serviceData?.getServiceListStatus?.data
        ?.recurringServiceTotalCount,
    totalLeftCount:
      store?.serviceData?.getServiceListStatus?.data
        ?.recurringServiceTotalLeftCount,
    createdDate: store?.serviceData?.getServiceListStatus?.data?.date,
    loading: store?.serviceData?.loading,
  }));

  useEffect(() => {
    dispatch(
      getServiceList({
        search: searchValue,
        pageCount: pageCount,
        pageLimit: pageLimit,
        sort_by: sortBy,
        sort_direction: sortDirection === "asc" ? "asc" : "desc",
        service_status: selectedStatus?.value || "",
        types: selectedType?.value || "",
        status: activeTab,
      })
    );
  }, [
    searchValue,
    pageCount,
    pageLimit,
    activeTab,
    sortBy,
    sortDirection,
    selectedStatus,
    selectedType,
    activeTab,
  ]);

  const tabs = [
    { label: "All", value: "all" },
    { label: "Pending", value: "Pending" },
    { label: "Scheduled", value: "Scheduled" },
    { label: "Completed", value: "Completed" },
    { label: "Cancelled", value: "Cancelled" },
  ];
  const handleOpenModal = (service) => {
    setSelectedService(service);
    setShowModal(true);
  };

  const ColumnHeaders = () => (
    <>
      <th
        scope="col"
        className="p-2 font-Proxima sm:text-sm text-xs font-normal py-4 px-4 text-mgrey text-start"
      >
        <div className="flex items-center">
          <div
            className="flex items-center"
            onClick={() => {
              setSortBy("id");
              setSortDirection(sortDirection === "desc" ? "asc" : "desc");
            }}
          >
            <span>No.</span>
            <SortDownArrow
              className={`ml-1 transition-transform duration-300 ${
                sortDirection === "asc" && sortBy === "id" ? "rotate-180" : ""
              }`}
            />
          </div>
        </div>
      </th>

      <th
        scope="col"
        className="p-2 font-Proxima sm:text-sm text-xs font-normal py-4 px-4 text-mgrey text-start"
      >
        <div
          className="flex items-center"
          onClick={() => {
            setSortBy("outlet");
            setSortDirection(sortDirection === "desc" ? "asc" : "desc");
          }}
        >
          <span>Outlets</span>
          <SortDownArrow
            className={`ml-1 transition-transform duration-300 ${
              sortDirection === "asc" && sortBy === "outlet" ? "rotate-180" : ""
            }`}
          />
        </div>
      </th>
      <th
        scope="col"
        className="p-2 font-Proxima sm:text-sm text-xs font-normal py-4 px-4 text-mgrey text-start"
      >
        <div
          className="flex items-center"
          onClick={() => {
            setSortBy("address");
            setSortDirection(sortDirection === "desc" ? "asc" : "desc");
          }}
        >
          <span>Address</span>
          <SortDownArrow
            className={`ml-1 transition-transform duration-300 ${
              sortDirection === "asc" && sortBy === "address"
                ? "rotate-180"
                : ""
            }`}
          />
        </div>
      </th>
      <th
        scope="col"
        className="p-2 font-Proxima sm:text-sm text-xs font-normal py-4  text-mgrey text-start"
      >
        <div
          className="flex items-center"
          onClick={() => {
            setSortBy("date");
            setSortDirection(sortDirection === "desc" ? "asc" : "desc");
          }}
        >
          <span>Date & Time</span>
          <SortDownArrow
            className={`ml-1 transition-transform duration-300 ${
              sortDirection === "asc" && sortBy === "date" ? "rotate-180" : ""
            }`}
          />
        </div>
      </th>
      <th
        scope="col"
        className="p-2 font-Proxima sm:text-sm text-xs font-normal py-4  text-mgrey text-start"
      >
        <div
          className="flex items-center"
          onClick={() => {
            setSortBy("technician");
            setSortDirection(sortDirection === "desc" ? "asc" : "desc");
          }}
        >
          <span>Technician</span>
          <SortDownArrow
            className={`ml-1 transition-transform duration-300 ${
              sortDirection === "asc" && sortBy === "technician"
                ? "rotate-180"
                : ""
            }`}
          />
        </div>
      </th>
      <th
        scope="col"
        className="p-2 font-Proxima sm:text-sm text-xs font-normal py-4 px-4 text-mgrey text-start"
      >
        <div
          className="flex items-center"
          onClick={() => {
            setSortBy("status");
            setSortDirection(sortDirection === "desc" ? "asc" : "desc");
          }}
        >
          <span>Status</span>
          <SortDownArrow
            className={`ml-1 transition-transform duration-300 ${
              sortDirection === "asc" && sortBy === "status" ? "rotate-180" : ""
            }`}
          />
        </div>
      </th>
      <th className="p-2 font-Proxima sm:text-sm text-xs font-normal py-4 px-4 text-mgrey text-start">
        Types
      </th>
      <th className="p-2 font-Proxima sm:text-sm text-xs font-normal py-4 px-4 text-mgrey text-start">
        Action
      </th>
    </>
  );

  const DataRows = () => (
    <>
      {getServiceListData?.data?.map((element, index) => (
        <tr
          key={index}
          className="font-Proxima sm:text-[14px] text-xs shadow-sm text-mgrey hover:bg-lightprimaryorange"
        >
          <td className="px-4 py-3">
            <div className="flex items-center lg:text-sm text-xs">
              {element?.unique_id || "-"}
            </div>
          </td>
          <td className="px-5 py-3 lg:text-sm text-xs">
            <div className="truncate-lines-3">
              {element?.outlets
                ?.map((tech) =>
                  tech?.outlet?.name
                    ?.toLowerCase()
                    ?.replace(/\b\w/g, (char) => char.toUpperCase())
                )
                .join(", ") || "-"}
            </div>
          </td>
          <td className="px-5 py-3 lg:text-sm text-xs">
            {element?.address
              ? element.address
                  .toLowerCase()
                  .replace(/\b\w/g, (char) => char.toUpperCase())
              : "-"}
          </td>
          <td className="px-5 py-3 lg:text-sm text-xs">
            {element?.date || "-"}
            <br />
            {element?.start_time && element?.end_time
              ? `${element.start_time} - ${element.end_time}`
              : "-"}
          </td>
          <td className="px-5 py-3 lg:text-sm text-xs">
            <div className="truncate-lines-3">
              {element?.technicians
                ?.map((tech) =>
                  tech.full_name
                    ?.toLowerCase()
                    ?.replace(/\b\w/g, (char) => char.toUpperCase())
                )
                .join(", ") || "-"}
            </div>
          </td>
          <td className="px-5 py-3 lg:text-sm text-xs">
            <div className="flex justify-start ">
              <Badge
                className={`capitalize whitespace-nowrap ${
                  element?.status === "completed"
                    ? "bg-bgGreen text-white"
                    : element?.status === "cancelled"
                    ? "border-borderRed text-red"
                    : element?.status === "pending"
                    ? "border-borderGrey text-black"
                    : element?.status === "accepted"
                    ? "bg-bgGreen text-white"
                    : element?.status == null
                    ? "border-none"
                    : element?.status === "accepted"
                    ? "bg-bgGreen text-white"
                    : element?.status === "approved"
                    ? "border-bgGreen text-bgGreen"
                    : element?.status === "incompleted"
                    ? "bg-themeBtn text-white"
                    : ""
                }`}
                value={
                  element?.status === "cancelled"
                    ? "Cancelled"
                    : element?.status === "accepted"
                    ? "Accepted"
                    : element?.status === "completed"
                    ? "Completed"
                    : element?.status === "pending"
                    ? "Pending"
                    : element?.status === "accepted"
                    ? "Accepted"
                    : element?.status === "approved"
                    ? "Approved"
                    : element?.status === "incompleted"
                    ? "Incomplete"
                    : element?.status == null
                    ? "-"
                    : "-"
                }
              />
            </div>
          </td>
          <td className="px-2 py-3 lg:text-sm text-xs">
            {element?.service_requests
              ?.map((tech) => tech?.service_request_type?.name)
              .join(", ") || "-"}
          </td>
          <td className="flex px-5 py-3">
            <Action
              optionList={
                <>
                  <li
                    className="flex gap-2 items-center px-6 py-2 bg-white hover:bg-hoverTheme transition duration-300 cursor-pointer"
                    onClick={() =>
                      navigate("/view-service", {
                        state: { service: element },
                      })
                    }
                  >
                    View
                  </li>
                  {element?.status === "incompleted" ? (
                    <li
                      className="flex gap-2 items-center px-6 py-2 bg-white hover:bg-hoverTheme transition duration-300 cursor-pointer"
                      onClick={() => handleOpenModal(element)}
                    >
                      Sign and Complete Request
                    </li>
                  ) : null}
                </>
              }
              ulClassName={
                element?.status === "incompleted"
                  ? "min-w-[16rem]"
                  : "min-w-[12rem]"
              }
            />
          </td>
        </tr>
      ))}
    </>
  );

  return (
    <>
      <div>
        <div className="flex justify-between items-start">
          <div>
            <h6 className="font-Montserrat font-medium text-xl mb-3">
              Service Request
            </h6>
            <Breadcrumb
              breadCrumbParent={"Home"}
              breadCrumbActive={"Service Request"}
              breadCrumbTitleKey={"/"}
              classes=""
            />
          </div>
        </div>
        {/* requeswt info div */}
        <div className="w-full mb-3 mt-3">
          <div className="bg-white p-6 rounded-lg shadow-md w-full shadow-borderDot  border border-borderDot">
            <div className="flex justify-between items-center">
              <div>
                <h2 className="sm:text-xl font-medium font-Montserrat text-mgrey">
                  Request Information:
                </h2>
                <p className="text-themeBtn sm:text-base text-sm font-normal font-Proxima">
                  Total Servicing Count: {totalCount ?? "-"}
                </p>
                <p className="text-themeBtn sm:text-base text-sm font-normal font-Proxima">
                  Total Servicing Count Left: {totalLeftCount ?? "-"}
                </p>
              </div>
              <div className="text-right">
                <p className="text-textSecondary sm:text-sm text-xs sm:text-left text-center font-normal font-Proxima">
                  Created On: {createdDate || "-"}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="flex mt-8">
          {tabs.map((tab) => (
            <button
              key={tab.value}
              className={`py-2  w-full font-normal mb-5 h-full px-1 sm:px-4 uppercase lg:text-[14px] text-xs border-b-2 transition duration-300 font-Proxima ${
                activeTab === tab.value
                  ? "border-themeBtn text-themeBtn"
                  : "border-transparent text-textSecondary hover:text-themeBtn hover:border-theme "
              }`}
              onClick={() => setActiveTab(tab.value)}
            >
              {tab.value}
            </button>
          ))}
        </div>

        <div className="flex sm:flex-row flex-col gap-3 items-center sm:space-x-3">
          <ReactSelect
            className={"w-full sm:max-w-52 text-black p-0 font-Proxima"}
            id="status"
            placeholder="Status"
            options={Status}
            isClearable={true}
            value={selectedStatus}
            onChange={(e) => {
              setSelectedStatus(e);
            }}
            styles={{
              control: (base) => ({
                ...base,
                border: `1px solid #0000003B`,
                borderColor: selectedStatus ? "#F15B29" : "#0000003B",
                borderRadius: "0.3rem",

                boxShadow: "none",
                "&:hover": {
                  border: "1px solid #0000003B",
                },
              }),
              option: (base, state) => ({
                ...base,
                backgroundColor: state.isSelected ? "#F15B29" : "white",
                "& :active": {
                  backgroundColor: state.isSelected
                    ? "#F15B29"
                    : "rgba(0, 0, 0, 0.04)",
                },
              }),
            }}
          />
          <ReactSelect
            className={"w-full sm:max-w-52 text-black p-0 font-Proxima"}
            id="type"
            placeholder="Types"
            options={Type}
            isClearable={true}
            value={selectedType}
            onChange={(e) => {
              setSelectedType(e);
            }}
            styles={{
              control: (base) => ({
                ...base,
                border: `1px solid #0000003B`,
                borderColor: selectedType ? "#F15B29" : "#0000003B",
                borderRadius: "0.3rem",

                boxShadow: "none",
                "&:hover": {
                  border: "1px solid #0000003B",
                },
              }),
              option: (base, state) => ({
                ...base,
                backgroundColor: state.isSelected ? "#F15B29" : "white",
                "& :active": {
                  backgroundColor: state.isSelected
                    ? "#F15B29"
                    : "rgba(0, 0, 0, 0.04)",
                },
              }),
            }}
          />
          <DebounceSearch
            className="full-width"
            search={searchValue}
            handleChange={setSearchValue}
            placeholder={"Search..."}
          />
        </div>

        {loading ? (
          <RippleLoader />
        ) : (
          <div className="w-full bg-white shadow rounded-lg mt-5 overflow-x-auto">
            <div className="min-w-[600px]">
              <CustomTable
                overflowVisibleLg={true}
                columnHeaders={<ColumnHeaders />}
                dataRows={<DataRows />}
                data={getServiceListData}
                loading={false}
                showPagination={true}
                setPaginationCurrentLimit={setPageLimit}
                paginationCurrentLimit={pageLimit}
                current={pageCount}
                total={getServiceListData?.total}
                paginationData={(crPage) => setPageCount(crPage)}
                lastPage={Math.ceil(getServiceListData?.total / pageLimit)}
              />
            </div>
          </div>
        )}
      </div>
      {showModal && (
        <SignatureModal
          onClose={() => setShowModal(false)}
          // onSave={handleSignatureSave}
          serviceId={selectedService?.id}
          search={searchValue}
          pageCount={pageCount}
          pageLimit={pageLimit}
          sort_by={sortBy}
          sort_direction={sortDirection}
          service_status={selectedStatus?.value}
          types={selectedType?.value}
          status={activeTab}
        />
      )}
    </>
  );
};

export default ServiceRequest;
